import gql from "graphql-tag";

export const CREATE_CRM_LEAD = gql`
  mutation AddCrmLead($data: CrmLeadDataInput) {
    addCrmLead(data: $data) { id email firstName lastName companyName }
  }
`;

export const UPDATE_CRM_LEAD = gql`
  mutation UpdateCrmLead($where: CrmLeadWhereInput, $data: CrmLeadDataInput) {
    updateCrmLead(where: $where, data: $data) { id }
  }
`;

export const DELETE_CRM_LEAD = gql`
  mutation DeleteCrmLead($where: CrmLeadWhereInput) {
    deleteCrmLead(where: $where) { id }
  }
`;

export const CREATE_CRM_CAMPAIGN_LEAD = gql`
  mutation AddCrmCampaignLead($data: CrmCampaignLeadDataInput) {
    addCrmCampaignLead(data: $data) { id status }
  }
`;

export const UPDATE_CRM_CAMPAIGN_LEAD = gql`
  mutation UpdateCrmCampaignLead($where: CrmCampaignLeadWhereInput, $data: CrmCampaignLeadDataInput) {
    updateCrmCampaignLead(where: $where, data: $data) { id }
  }
`;

export const DELETE_CRM_CAMPAIGN_LEAD = gql`
  mutation DeleteCrmCampaignLead($where: CrmCampaignLeadWhereInput) {
    deleteCrmCampaignLead(where: $where) { id }
  }
`;

const crmLeads = {
  CREATE_CRM_LEAD, UPDATE_CRM_LEAD, DELETE_CRM_LEAD,
  CREATE_CRM_CAMPAIGN_LEAD, UPDATE_CRM_CAMPAIGN_LEAD, DELETE_CRM_CAMPAIGN_LEAD,
};
export default crmLeads;
